import TemplatePageContainer from './TemplatePageContainer';
import React, { CSSProperties, ReactNode, useMemo } from 'react';
import { useRouteMatch } from 'react-router-dom';
import routes, { registerModalRoute } from '../routes';
import { appendPageIdToUrl, cleanURLCompoment } from '../helpers/utils';
import ModalLink from './Modal/ModalLink';
// @ts-ignore
import { Facebook, Twitter, Whatsapp } from 'react-social-sharing';

type SocialSharingPageProps = {
  url: string;
  message: string;
};

export const SocialSharingPage = ({ url, message }: SocialSharingPageProps) => {
  return (
    <TemplatePageContainer>
      <Facebook solid big link={url} message={message} />
      <Twitter solid big link={url} message={message} />
      <Whatsapp solid big link={url} message={message} />
    </TemplatePageContainer>
  );
};

type SocialSharingLinkProps = {
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
};

export const createSocialSharingLink = ({
  title = '',
  message = '',
  url = 'https://www.piggyvest.com'
}: {
  title?: string;
  message?: string;
  url?: string;
}) => {
  return ({ className = '', style = {}, children }: SocialSharingLinkProps) => {
    const match = useRouteMatch();
    const shareRouteId = useMemo(() => {
      const routeId = 'Share';
      title = cleanURLCompoment(title);
      message = cleanURLCompoment(message);
      registerModalRoute(routeId, appendPageIdToUrl(match.url, 'share'), {
        headerTitle: title?.replace('+', ' ') ?? '',
        content: <SocialSharingPage url={url} message={message} />
      });
      return routeId;
    }, [match.url]);
    return (
      <ModalLink to={routes[shareRouteId]} className={className} style={style}>
        {children}
      </ModalLink>
    );
  };
};
